export default {"src":"/_next/static/media/squares.a57ab678.svg","height":57,"width":38};